/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { Button, Link, Box, SvgIcon } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { handleFormInputChange, handleFormValidation } from '../../common/utilities/CustomValidatorUtil';
import { validationCheck } from '../../common/utilities/HandleVerifyUserUtil';
import { fetchVerifyUserEncrypt } from '../../common/services/proxyServices';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import CustomToolTip from '../../components/common/CustomToolTip'
import '../../common/theme/UserFlowPage.scss';
import overrides from '../../common/theme/OverrideStyles'
import  CommonBannerComponent  from '../../components/common/CommonBannerComponent/CommonBannerComponent';
import appSettings from '../../appSettings';
import { handleDateChange } from '../../common/utilities/CustomFormatUtil';

const defaultTheme = createTheme();
const theme = createTheme(overrides);
const UserInfoComponent = ({ sendEncryptedUserData,selectedUserType, handlePrevStep }) => {
  const initialFormValues = {
    username: '',
    dateofbirth: '',
    npn: '',
  };
  const initialErrors = {
    username: '',
    dateofbirth: '',
    npn: '',
  };
  const initialIsLicensedValue = selectedUserType === 'licensed' ? true : false;
  const [encryptedData, setEncryptedUserData] = useState();
  const { formValues, setFormValues, errors, setErrors, isLicensed, setIsLicensed, licensedData, showBannerType, setShowBannerType, setIsEditable, isEditable, isValid, setIsValid, setIsLoading, loaderStyle } = HandleFormUtil(initialFormValues, initialErrors, initialIsLicensedValue);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if(licensedData !== undefined && licensedData.canEnroll && licensedData.errorCode === '') {
      onValidateAgent(false);
    }
  }, [licensedData]);  

  const continueAction = async (action) => {
    switch (action) {
      case 'Log in':
        window.location.replace(appSettings.AZURE_AD_CLIENT_REDIRECT_URI);
        break;
      case 'Continue':
        sendEncryptedUserData(encryptedData);
        break;
      default:
        break;
    }
  }

  const onInputChange = (event) => {
    handleFormInputChange(event, setFormValues);
  };
  
  const onValidation = (event) => {
    handleFormValidation(event, setErrors, validationCheck);
  };

  useEffect(() => {
    if(licensedData !== undefined && licensedData.canEnroll) {
        onValidateAgent(false);     
    }
  }, [licensedData]);  


  const handleDateChange = (event) => {
    let value = event.target.value; // YYYY-MM-DD format from date input

    if (value) {
      let [year, month, day] = value.split('-');
  
      // Ensure the year is only 4 digits
      if (year.length > 4) {
        year = year.slice(0, 4);
        value = `${year}-${month}-${day}`;
        event.target.value = value; 
      }
    }
    onInputChange(event);
  };
  
  const onValidateAgent = async () => {
    try {
      setIsLoading(true);
      const verifiedUser = await fetchVerifyUserEncrypt(formValues);
      if (verifiedUser.errorCode) {
        if(verifiedUser.errorCode === 'E200') {
          setIsLicensed(true);
          setIsEditable(false);
        }
        if(verifiedUser.errorCode === 'INFO') {
          setEncryptedUserData(verifiedUser.data);
          verifiedUser.errorCode = verifiedUser.errorCode.toLowerCase();
          setIsEditable(false);
        }
        setIsValid(false);
        setIsLoading(false);
        setShowBannerType(verifiedUser.errorCode);
        return;
      }
      sendEncryptedUserData(verifiedUser.data);
      setIsValid(false);
    } catch (error) {
      setIsLoading(false);
      setIsValid(false);
      setShowBannerType('E900');
    }
  };

  return (
    <>
      <div className='userFlowText licensed-agent'>
        <div className='eyebrow'>
          Create an account:  {isLicensed ? 'Licensed agent' : 'Non-licensed agent'}
        </div>
        <div className='title'>
          Enter information
        </div>
        <CommonBannerComponent bannerState='inline' bannerType={showBannerType} continueAction={continueAction} />
        <p className='userFlow-content'>
          Please provide the information below. If you are a new user,
          'username' can be found in your Welcome email.
        </p>
        <ThemeProvider theme={defaultTheme}>
          <form>
            <div className='userFlow-field'>
              <div className='userFlow-tooltip'>
                <label htmlFor='username' >
                  Username
                </label>
                <ThemeProvider theme={theme}>
                  <CustomToolTip message={<div className='tooltip-content'>If you are a new user, 'username' can be found in your Welcome email. If you are a returning user, please enter your modernLINK username.</div>}></CustomToolTip>
                </ThemeProvider>
              </div>
              <input
                id='username'
                className={`inputfield ${errors.username ? 'errorfocus' : ''
                  }`}
                placeholder='Enter your username'
                onChange={onInputChange}
                onBlur={onValidation}
                disabled={!isEditable}
              />
              {errors.username && (
                <span className='errormsg'>{errors.username}</span>
              )}
            </div>
            <div className={(isLicensed || selectedUserType === 'licensed') ? 'dob-npn' : 'dob'}>
              <div className={(isLicensed || selectedUserType === 'licensed') ? 'dob-field' : ''} >
                <label
                  htmlFor='dateofbirth'
                >
                  Date of birth
                </label>
                <input
                  id='dateofbirth'
                  type='date'
                  onChange={(event) => handleDateChange(event, onInputChange)}
                  onBlur={onValidation}
                  name='dob'
                  disabled={!isEditable}
                  className={`${
                    formValues.dateofbirth ? 'dob--has-value' :
                    errors.dateofbirth ? 'errorfocus' :
                    ''}`}
                />
                {errors.dateofbirth && (
                  <span className='errormsg'>{errors.dateofbirth}</span>
                )}
              </div>
              {(isLicensed || selectedUserType === 'licensed') && (
                <div className='npn-field'>
                  <div className='npn-tooltip'>
                    <label
                      htmlFor='npn'
                      className='npn-label'
                    >
                      National Producer Number (NPN)
                    </label>
                    <ThemeProvider theme={theme}>
                    <CustomToolTip message={<div className='tooltip-content'><div>You can search for your National Producer Number here</div><div><a href="https://nipr.com/licensing-center/look-up-a-national-producer-number" target="_blank" rel='noreferrer'>https://nipr.com/licensing-center/look-up-a-national-producer-number</a></div></div>}></CustomToolTip>
                    </ThemeProvider>
                  </div>
                  <input
                    id='npn'
                    className={`${errors.npn ? 'errorfocus' : ''} ${!initialIsLicensedValue ? 'highlight' : ''}`}
                    placeholder='Enter your NPN'
                    variant='outlined'
                    onChange={onInputChange}
                    onBlur={onValidation}
                  />
                  {errors.npn && (
                    <span className='errormsg'>{errors.npn}</span>
                  )}
                </div>
              )}
            </div>
          </form>
        </ThemeProvider>
      </div>
      <Box className='buttonsBox'>
        <div className='continueButton'>
          <Button
            disableRipple
            disabled={!isValid}
            className='button-styling continue-button'
            style={loaderStyle}
            onClick={() => onValidateAgent(true)}
            aria-disabled={!isValid}
          >
            Continue
          </Button>
        </div>
        <div className='backButton'>
          <Button
            disableRipple
            component={Link}
            color='primary'
            onClick={() => {
              handlePrevStep('userType')
            }}
            className='back-button'
          >
            <SvgIcon
              className='back-arrow'
              component={ArrowBackIosIcon}
            />
            <span>Back</span>
          </Button>
        </div>
      </Box>
    </>
  );
};

export default UserInfoComponent;
